"use client"

import { cn } from '@/lib/utils'

interface LoaderProps {
  className?: string
  size?: number // px
  label?: string
}

export function Loader({ className, size = 48, label }: LoaderProps) {
  const dim = `${size}px`
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)} role="status" aria-live="polite">
      <div
        className="relative"
        style={{ width: dim, height: dim }}
      >
        {/* Outer glow ring */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-indigo-500/20 via-sky-500/20 to-emerald-500/20 blur-md" />
        {/* Spinner */}
        <div className="absolute inset-0 rounded-full border-2 border-muted-foreground/20" />
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent border-t-indigo-500 border-r-sky-500 animate-spin"
          style={{ animationDuration: '900ms' }}
        />
        {/* Center dot */}
        <div className="absolute inset-0 m-auto h-2 w-2 rounded-full bg-indigo-500/80" />
      </div>
      {label && (
        <div className="text-sm text-muted-foreground">{label}</div>
      )}
    </div>
  )
}
